/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.openai.integration.rpc.AppSettingsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type ApiKeyUpdateRequest = { apiKey: string };

export type ApiKeyUpdateResponse = {};

export type AppInstallRequest = { apiKey: string };

export type AppInstallResponse = { responseField: string };

export type GenerateImageData = {
  b64Json?: string;
  url?: string;
  revisedPrompt?: string;
};

export type GenerateImageRequest = {
  prompt: string;
  model?: string;
  n?: number;
  quality?: string;
  responseFormat?: string;
  size?: string;
  style?: string;
  user?: string;
};

export type GenerateImageResponse = {
  created: number;
  data: Default<GenerateImageData[]>;
};

export type GenerateResponseAnnotation = {
  endIndex: number;
  startIndex: number;
  title: string;
  type: string;
  url: string;
};

export type GenerateResponseOutput = {
  content?: GenerateResponseOutputContent[];
  id: string;
  role?: string;
  status?: string;
  type: string;
};

export type GenerateResponseOutputContent = {
  annotations: Default<GenerateResponseAnnotation[]>;
  text: string;
  type: string;
};

export type GenerateResponseRequest = {
  input: string;
  model: string;
  instructions?: string;
  reasoning?: string;
  temperature?: number;
  tools?: GenerateResponseTool[];
};

export type GenerateResponseResponse = {
  id: string;
  object: string;
  model: string;
  status: string;
  output: Default<GenerateResponseOutput[]>;
};

export type GenerateResponseTool = {
  type: string;
  serverLabel?: string;
  serverUrl?: string;
  requireApproval?: string;
  headers?: Record<string, string>;
  searchContextSize?: string;
};

export type OpenAIAppError = {
  customMessage?: string;
  chirpErrorMessage: Default<string>;
  type: ErrorType;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ErrorType = 'INVALID_API_KEY' | 'API_ERROR' | unhandledEnumCase;

export type InstallRequestType = Requestify<AppInstallRequest>;
export type InstallResponseType = AppInstallResponse;
export type InstallErrorType = OpenAIAppError & HubspotMetadata;
export const installRpc: ChirpAvroRpcDetails<
  InstallRequestType,
  InstallResponseType,
  InstallErrorType,
  false
> = {
  serviceName: 'com.hubspot.openai.integration.rpc.AppSettingsRpc',
  rpcName: 'install',
  auth: 'app',
  fingerprint: 'z-dmJq6t5IZjvrSLmLLPi0Uk7jIzIOtx',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UninstallResponseType = AppInstallResponse;
export type UninstallErrorType = OpenAIAppError & HubspotMetadata;
export const uninstallRpc: ChirpAvroRpcDetails<
  undefined,
  UninstallResponseType,
  UninstallErrorType,
  false
> = {
  serviceName: 'com.hubspot.openai.integration.rpc.AppSettingsRpc',
  rpcName: 'uninstall',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABjvrSLmLLPi0Uk7jIzIOtx',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpsertApiKeyRequestType = Requestify<ApiKeyUpdateRequest>;
export type UpsertApiKeyResponseType = ApiKeyUpdateResponse;
export type UpsertApiKeyErrorType = OpenAIAppError & HubspotMetadata;
export const upsertApiKeyRpc: ChirpAvroRpcDetails<
  UpsertApiKeyRequestType,
  UpsertApiKeyResponseType,
  UpsertApiKeyErrorType,
  false
> = {
  serviceName: 'com.hubspot.openai.integration.rpc.AppSettingsRpc',
  rpcName: 'upsertApiKey',
  auth: 'app',
  fingerprint: 'W8Fv60z6eU9g9V5a4HKmfkUk7jIzIOtx',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GenerateResponseRequestType = Requestify<GenerateResponseRequest>;
export type GenerateResponseResponseType = GenerateResponseResponse;
export type GenerateResponseErrorType = OpenAIAppError & HubspotMetadata;
export const generateResponseRpc: ChirpAvroRpcDetails<
  GenerateResponseRequestType,
  GenerateResponseResponseType,
  GenerateResponseErrorType,
  false
> = {
  serviceName: 'com.hubspot.openai.integration.rpc.AppSettingsRpc',
  rpcName: 'generateResponse',
  auth: 'app',
  fingerprint: 'dUQasEiJHi25k65gAtEHx0Uk7jIzIOtx',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GenerateImageRequestType = Requestify<GenerateImageRequest>;
export type GenerateImageResponseType = GenerateImageResponse;
export type GenerateImageErrorType = OpenAIAppError & HubspotMetadata;
export const generateImageRpc: ChirpAvroRpcDetails<
  GenerateImageRequestType,
  GenerateImageResponseType,
  GenerateImageErrorType,
  false
> = {
  serviceName: 'com.hubspot.openai.integration.rpc.AppSettingsRpc',
  rpcName: 'generateImage',
  auth: 'app',
  fingerprint: 'rfCQI9Fq77XZ7XU3ArvPmUUk7jIzIOtx',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
